import { render, staticRenderFns } from "./EditCif.vue?vue&type=template&id=6eb97b39&scoped=true"
import script from "./EditCif.vue?vue&type=script&lang=js"
export * from "./EditCif.vue?vue&type=script&lang=js"
import style0 from "./EditCif.vue?vue&type=style&index=0&id=6eb97b39&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb97b39",
  null
  
)

export default component.exports